module.exports = __webpack_public_path__ + "static/media/logo-grey.7f2b7e60.png";